import {RootState} from "../RootReducer";
import {createSelector} from "@reduxjs/toolkit";

export const alertSelector = createSelector(
    [(state: RootState) => state.alert,(_state: RootState, id: string) => id],
(alerts,id:string) => {
  return alerts.byId[id];
});